import templateUrl from "emun.auth/reset-password/reset-password-prompt.htm";
import controller from "emun.auth/reset-password/reset-password.controller";
import open from "webmodals/open";

export default ({
  size = "md",
  backdrop = "static",
  headerText = "Reset password",
  submitText = "Request Verification Link...",
  title = headerText,
  callbackUrl,
  userName,
  email
}) =>
  open({
    size,
    backdrop,
    templateUrl,
    controller,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      title: () => title,
      submitText: () => submitText,
      request: () => ({ userName, email, callbackUrl })
    }
  }).result;
